import { hasPresentValue } from 'utils'

const isMissingMinutesInCourses = (courses) => {
  return !courses.every((course) =>
    hasPresentValue(course.averageMinutesPerWeek)
  )
}
export default isMissingMinutesInCourses
